const transformProductsAttributeOption = ({ key , label , swatch  }, { attributeType  } = {})=>{
    return {
        ...label ? {
            label
        } : {},
        ...swatch ? {
            type: swatch?.type === 'swatch' ? 'image' : swatch?.type === 'color' ? 'hex' : 'text',
            src: swatch?.type === 'swatch' ? swatch.value : null,
            hex: swatch?.type === 'color' ? swatch.value : null
        } : {},
        ...attributeType === 'boolean' ? {
            value: key === '0' ? false : key === '1' ? true : key === ' ' ? null : key
        } : {},
        ...key ? {
            id: Array.isArray(key) ? key.map(parseInt) : parseInt(key)
        } : {}
    };
};
const transformProductsAttributeResponse = ({ code , title , type , options , ...data })=>{
    return {
        code,
        title,
        type,
        options: options.map((option)=>transformProductsAttributeOption(option, {
                attributeType: type
            })),
        ...data
    };
};
const transformProductsAttributesResponse = (data)=>{
    return data?.map(transformProductsAttributeResponse);
};

export { transformProductsAttributeOption, transformProductsAttributeResponse, transformProductsAttributesResponse };
